<template>
  <div class="product-description">
    <component
      :is="componentType"
      :title="(clickAction!=='disabled') ? product?.detail?.brand?.name : null"
      :href="(clickAction!=='disabled') && product?.detail?.brand?.name ? product?.detail?.brand?.url : null"
      :aria-labelledby="(clickAction!=='disabled') ? product?.detail?.brand?.name : null"
      :class="['brand', { 'clickAction' :clickAction === 'fireEvent'}]"
      v-bind="extraAttributes"
    >
      <div
        v-if="product?.detail?.brand?.name"
        class="eyebrow"
      >
        {{ product?.detail?.brand?.name }}
      </div>
    </component>
    <div
      v-if="product?.detail?.name"
      class="h4 detail-name"
    >
      {{ product?.detail?.name }}
    </div>
    <template v-if="product">
      <LargeCardPricingBlock
        v-if="!isOutOfStock"
        :is-large-card="isLargeCard"
        :pricing=" updatePricingOnColorChange(largeCardSelectedPrice) || genLargeCardPricing(product, largeCardSelectedColor)"
      />
    </template>
    <template v-if="productReviews">
      <Reviewlet
        size="small"
        :review-count="productReviews?.count"
        :rating="productReviews?.rating"
        :show-review-text="isLargeCard"
        :show-rating="isLargeCard"
        :review-link="reviewLink"
      />
    </template>
  </div>
</template>

<script>
import Reviewlet from '@atomic-ui/reviewlet';
import LargeCardPricingBlock from './LargeCardPricingBlock';

export default {
  name: 'ProductDescription',

  components: {
    LargeCardPricingBlock,
    Reviewlet,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    clickAction: {
      type: String,
      default: 'linkToPdp',
    },
    isLargeCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    largeCardSelectedColor: {
      type: Number,
      required: false,
      default: null,
    },
    largeCardSelectedPrice: {
      type: Object,
      default: () => {},
      required: false,
    },
    reviewLink: {
      required: false,
      type: String,
      default: null,
    },
    openInNewTab: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['setSelectedColor'],

  computed: {
    productReviews() {
      return this.product?.detail?.reviewStatistics?.aggregate;
    },
    marketPlaceSellerName() {
      return this.product?.mkpLineItemDetails?.sellerName;
    },
    isOutOfStock() {
      const upcMap = this.product?.traits?.traitsMaps?.upcMap;
      return upcMap && Object.keys(upcMap).length === 0;
    },
    componentType() {
      return (this.clickAction !== 'disabled') && this.product.detail?.brand?.name ? 'a' : 'div';
    },
    extraAttributes() {
      if (this.componentType === 'a') {
        return this.openInNewTab ? { target: '_blank', rel: 'noopener' } : { target: '_self' };
      } return null;
    },
  },
  methods: {
    genLargeCardPricing(product, colorId) {
      const colorMap = product?.traits?.colors?.colorMap;
      return colorMap?.find((color) => color.id === colorId)?.pricing?.price;
    },
    updatePricingOnColorChange(price) {
      if (price && Object.keys(price).length === 0) return null;
      return price;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-description {
  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  .clickAction{
    cursor: pointer;
  }
}

.is-large-card .product-description {
  display: flex;
  flex-direction: column;
  .brand{
    order: 1;
  }
  .detail-name{
     order: 2
  }
  :deep(.rating) {
    order: 3;
  }
  .pricing {
    order: 4;
  }
}

.is-large-card {
  .product-description {
    .eyebrow, .h4 {
      margin-bottom: rem-calc(12);
    }
    :deep(.rating) {
      margin-top: 0;
      margin-bottom: rem-calc(24);
    }
    .pricing {
      font-weight: $font-weight-med;
      font-size: $font-size-lg;
      line-height: $line-height-lg;
      margin-top: 0;
      margin-bottom: rem-calc(24);
    }
  }

}
</style>

<style lang="scss" brand="mcom" scoped>
@import "@csgIcons/_chevron-small-down-black.scss";
@import "@csgIcons/_chevron-small-up-black.scss";

.product-description {
  .arrow-down {
    @extend .chevron-small-down-black;
  }
  .arrow-up {
    @extend .chevron-small-up-black;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
@import "@csgIcons/_chevron-small-down.scss";
@import "@csgIcons/_chevron-small-up.scss";
.product-description {
  .arrow-down {
    @extend .chevron-small-down;
  }
  .arrow-up {
    @extend .chevron-small-up;
  }
}
.is-large-card {
  .product-description {
    .pricing {
      font-weight: $font-weight-med;
      font-size: $font-size-med;
      line-height: $line-height-med;
      letter-spacing: $body-letter-spacing;
    }
  }

}
</style>
